
export const setDBUriState = (state, dbUri) => {
  state.dbUri = dbUri;
};

export const setShowPrintConfirmDialog = (state, showValue) => {
  state.printConfirmDialog = showValue;
};

export const setInvoiceDetailDialog = (state, showValue) => {
  state.invoiceDetailDialog = showValue;
};
export const setItemDetailsDialogItem = (state, item) => {
  state.invoiceDetailsItem = item;
};

export const setSuccessModal = (state, showValue) => {
  state.successModal = showValue;
};

export const setSuccessModalMessage = (state, successMessage) => {
  state.successModalMessage = successMessage;
};

export const setNavDatePickerModal = (state, showValue) => {
  state.navDatePickerModal = showValue;
};

export const setLoadingIndicator = (state, showValue) => {
  state.loadingIndicator = showValue;
};

export const setCurrentUser = (state, user) => {
  state.currentUser = user;
};

export const setUnauthNavAttemptUrl = (state, routerIntentUrl) => {
  state.unauthNavAttemptUrl = routerIntentUrl;
};

export const setCategorias = (state, categoriasPayload) => {
  state.categorias = categoriasPayload; //getCategoriasAll();
};

export const setServicios = (state, serviciosPayload) => {
  const services = serviciosPayload; //getServiciosAll();
  const newServicios = services.map(servicio => {
    const serviceCategory = state.categorias.find(categoria => categoria.id === servicio.id_categoria);
    const modifiedService = {
      ...servicio,
      categoria: serviceCategory.categoria
    };
    return modifiedService;
  });
  state.servicios = newServicios;
};

export const setProductos = (state, productosPayload) => {
  const products = productosPayload; //getProductosAll();
  const newProducts = products.map(producto => {
    const productCategory = state.categorias.find(categoria => categoria.id === producto.id_categoria);
    const modifiedProduct = {
      ...producto,
      categoria: productCategory.categoria
    };
    return modifiedProduct;
  });
  state.productos = newProducts;
};

export const setChargeBillModalStatus = (state, newStatus) => {
  state.isChargeBillModalOpen = newStatus;
};

export const setEntregarServicioModalStatus = (state, newStatus) => {
  state.isEntregarServicioModalOpen = newStatus;
};

export const setInvoicesToCharge = (state, newInvoice) => {
  state.invoicesToCharge = [
    ...state.invoicesToCharge,
    newInvoice
  ];
};

export const setNewClientAdded = (state, newClientPayload) => {
  state.newClientWasAdded = newClientPayload;
};